import { render, staticRenderFns } from "./LoadingOrderEditor.vue?vue&type=template&id=00b098af"
import script from "./LoadingOrderEditor.vue?vue&type=script&lang=js"
export * from "./LoadingOrderEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports